import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { patchAdminFeatureFlagByIdSlice } from './patch';

import { adminFeatureFlagByCustomerIdReducers, adminFeatureFlagByCustomerIdWatchers } from './customer';

export const adminFeatureFlagByIdReducers = combineReducers({
	customer: adminFeatureFlagByCustomerIdReducers,
	patch: patchAdminFeatureFlagByIdSlice.asyncReducers
});

export const adminFeatureFlagByIdWatchers = combineAllWatchers([
	adminFeatureFlagByCustomerIdWatchers,
	patchAdminFeatureFlagByIdSlice.asyncWatchers
]);

